import * as yup from 'yup'

export const schemaSupplier = yup.object().shape({
  document: yup.string().required(),
})

export default schemaSupplier
